import React, { FC, memo, useCallback } from 'react'

import { ShopDriverTipVariant } from 'Types'

interface Props {
  applyTipVariant({ doorDashAmount }: { doorDashAmount: number }): void
  tipVariant: ShopDriverTipVariant
}

const DoorDashTipVariantBtn: FC<Props> = ({ tipVariant, applyTipVariant }) => {
  const handleClick = useCallback(() => {
    applyTipVariant({ doorDashAmount: tipVariant.amount })
  }, [applyTipVariant, tipVariant.amount])

  return (
    <button className="tips__btn / btn btn-accent / text-uppercase" type="button" onClick={handleClick}>
      <b>{tipVariant.percentage}%</b>
      <span>{tipVariant.amountFormatted}</span>
    </button>
  )
}
export default memo(DoorDashTipVariantBtn)
